import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { alpha } from '@mui/material/styles';
import { PROMETHEAN_NEUTRAL_GREY_200, PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_NEUTRAL_DARK_GREY_PLUM, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_LAVENDER, PROMETHEAN_BLUE, PROMETHEAN_DARK_PURPLE } from '../../../../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE } from '../../../../styles/typography/typography';
export var FilterTagsContainer = styled('div')({
  '&.EmbersFilterTags': {
    display: 'flex',
    alignItems: 'baseline',
    '.tags-label': _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_EYEBROW_UPPERCASE), {}, {
      color: PROMETHEAN_NEUTRAL_DARK_GREY_PLUM,
      display: 'inline-flex',
      marginRight: 8
    }),
    '.tags-container': {
      display: 'inline-flex',
      columnGap: 16,
      rowGap: 8,
      flexWrap: 'wrap',
      flexGrow: 1,
      flexShrink: 1,
      minWidth: 0,
      maxWidth: '100%',
      marginTop: 23,
      '.MuiChip-filled': {
        minWidth: 0,
        background: PROMETHEAN_NEUTRAL_GREY_200,
        color: PROMETHEAN_PURPLE_GRAPE,
        padding: '4px 12px',
        '.MuiChip-label': {
          margin: '0px 8px 0 4px',
          padding: 0
        },
        '.MuiChip-deleteIcon': {
          color: PROMETHEAN_PURPLE_GRAPE,
          margin: 0
        },
        '&.Mui-focusVisible': {
          padding: '1px 9px',
          outline: "2px solid ".concat(PROMETHEAN_BLUE),
          outlineOffset: 1,
          height: 18,
          margin: 3,
          color: PROMETHEAN_DARK_PURPLE,
          backgroundColor: alpha(PROMETHEAN_DARK_PURPLE, 0.2)
        }
      },
      '&.tags-in-modal': {
        rowGap: 16,
        paddingBottom: 32,
        marginTop: 0
      },
      '.EmbersButton-hasEndIcon': {
        background: 'transparent',
        '&:hover': {
          backgroundColor: PROMETHEAN_LIGHT_PURPLE
        },
        '&:active': {
          backgroundColor: PROMETHEAN_LAVENDER
        }
      }
    },
    '&:not(.EmbersFilterTags-mobile)': {
      '.tags-container': {
        'div:last-child': {
          flexGrow: 1,
          columnGap: 16,
          display: 'flex',
          justifyContent: 'space-between',
          minWidth: 0
        }
      }
    },
    '&.EmbersFilterTags-mobile': {
      display: 'flex',
      flexDirection: 'column',
      '.tags-container': {
        'div:last-child': {
          flexGrow: 0,
          display: 'flex',
          justifyContent: 'inherit'
        },
        '&.tags-in-modal': {
          paddingBottom: 0
        }
      },
      '.EmbersFilterTags-clearAll': {
        paddingBottom: 32,
        width: '100%',
        textAlign: 'right'
      }
    }
  }
});